import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";



// ─── Warning Icon ─────────────────────────────────────────────────────────────
function WarnIcon() {
  return (
    <svg viewBox="0 0 20 20" fill="currentColor" className="w-4 h-4 shrink-0 mt-0.5">
      <path
        fillRule="evenodd"
        d="M8.485 2.495c.673-1.167 2.357-1.167 3.03 0l6.28 10.875c.673 1.167-.17 2.625-1.516 2.625H3.72c-1.347 0-2.189-1.458-1.515-2.625L8.485 2.495zM10 6a.75.75 0 01.75.75v3.5a.75.75 0 01-1.5 0v-3.5A.75.75 0 0110 6zm0 9a1 1 0 100-2 1 1 0 000 2z"
        clipRule="evenodd"
      />
    </svg>
  );
}

// ─── AlertModal ───────────────────────────────────────────────────────────────
function AlertModal({ onClose }) {
  return (
    <AnimatePresence>
      {/* Backdrop */}
      <motion.div
        key="backdrop"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        className="fixed inset-0 z-50 flex items-center justify-center p-4"
        style={{ backdropFilter: "blur(6px)" }}
        onClick={onClose}
      >
        {/* Modal Card */}
        <motion.div
          key="modal"
          initial={{ opacity: 0, scale: 0.88, y: 32 }}
          animate={{ opacity: 1, scale: 1, y: 0 }}
          exit={{ opacity: 0, scale: 0.92, y: 20 }}
          transition={{ type: "spring", stiffness: 320, damping: 28 }}
          onClick={(e) => e.stopPropagation()}
          className="relative w-full max-w-md rounded-3xl overflow-hidden shadow-2xl"
          style={{ background: "#3b3b4d" }}
        >

          {/* ── Close button ── */}
          <button
            onClick={onClose}
            className="absolute top-4 right-4 z-10 w-8 h-8 rounded-full bg-white/10 hover:bg-white/20 flex items-center justify-center transition-colors"
          >
            <svg viewBox="0 0 16 16" fill="none" className="w-3.5 h-3.5 text-white/70">
              <path d="M3 3l10 10M13 3L3 13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
            </svg>
          </button>

          {/* ── Header ── */}
          <div className="relative px-8 pt-10  text-center">
            {/* Radial glow behind shield */}
            <div
              className="absolute top-0 left-1/2 -translate-x-1/2 w-56 h-56 rounded-full pointer-events-none"
              style={{
                background: "radial-gradient(circle, rgba(244,63,94,0.18) 0%, transparent 70%)",
              }}
            />
            <span className="inline-flex items-center gap-1.5 bg-rose-500/10 border border-rose-500/30 text-rose-400 text-[10px] font-bold tracking-[0.2em] uppercase px-3 py-1 rounded-full mb-3">
              <WarnIcon />
              Security Warning
            </span>
            <h2 className="text-2xl font-black text-white tracking-tight leading-tight capitalize">
              Be Alert !
            </h2>
          </div>

          {/* ── Divider ── */}
          <div className="mx-8 h-px bg-white/8" />

          {/* ── Body ── */}
          <div className="px-8 py-6 space-y-4">
            {/* Alert item 1 */}
            <div className="flex gap-3 p-4 rounded-2xl bg-white/[0.04] border border-white/8">
              <div className="w-8 h-8 rounded-xl bg-rose-500/15 flex items-center justify-center shrink-0">
                <span className="text-base">🚫</span>
              </div>
              <div>
                <p className="text-[13px] text-white/60 leading-relaxed">
                  <span className="text-rose-400 font-bold">kgstechgroupjobs.com</span>
                  {" "}is <span className="text-white font-semibold">not our domain</span>. Emails from this address are fraudulent and not from us.
                </p>
              </div>
            </div>

            {/* Alert item 2 */}
            <div className="flex gap-3 p-4 rounded-2xl bg-white/[0.04] border border-white/8">
              <div className="w-8 h-8 rounded-xl bg-amber-500/15 flex items-center justify-center shrink-0">
                <span className="text-base">🔍</span>
              </div>
              <div>
                <p className="text-[13px] text-white/60 leading-relaxed">
                  Before accepting any job offer from{" "}
                  <span className="text-white font-semibold">KGS Technology Group Inc</span>,
                  always verify the sender domain to avoid a job scam.
                </p>
              </div>
            </div>

            {/* Alert item 3 */}
            <div className="flex gap-3 p-4 rounded-2xl bg-white/[0.04] border border-white/8">
              <div className="w-8 h-8 rounded-xl bg-emerald-500/15 flex items-center justify-center shrink-0">
                <span className="text-base">✅</span>
              </div>
              <div>
                <p className="text-[13px] text-white/60 leading-relaxed">
                  Our <span className="text-white font-semibold">only official domain</span> is{" "}
                  <span className="text-emerald-400 font-bold">kgstechnologygroup.com</span>.
                  We do not own any other domain.
                </p>
              </div>
            </div>
          </div>

          {/* ── Footer ── */}
          <div className="px-8 pb-8 flex flex-col gap-3">
          
            <button
              onClick={onClose}
              className="w-full py-3 rounded-2xl bg-white/5 hover:bg-white/10 text-white/50 hover:text-white/80 font-semibold text-sm transition-all duration-200"
            >
              I understand, close this
            </button>
          </div>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
}

export default AlertModal;